const placeholderPattern = /\{([a-zA-Z0-9_.-]+)\}/g;

export function formatText(template, values = {}) {
  return String(template || '').replace(placeholderPattern, (match, key) => {
    if (!Object.prototype.hasOwnProperty.call(values, key)) {
      return match;
    }
    const value = values[key];
    return value === null || value === undefined ? '' : String(value);
  });
}

export function mergeCatalogs(catalogs = []) {
  return catalogs.reduce((messages, catalog) => ({
    ...messages,
    ...(catalog || {}),
  }), {});
}

export function translateMessage(messages, key, values = {}, fallback = '') {
  const message = messages?.[key];
  if (typeof message === 'string') {
    return formatText(message, values);
  }
  if (fallback) {
    return formatText(fallback, values);
  }
  return key;
}
